export const initialProducts = [
  {
    id: "1",
    name: "Ceylon Cinnamon C5 Special Grade",
    price: 24.99,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313478/4_hyjqbc.png",
    category: "Spices",
    description: "Export grade authentic Sri Lankan cinnamon."
  },
  {
    id: "2",
    name: "Virgin Coconut Oil - Whole Kernel",
    price: 18.50,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316112/5_eutjy2.png",
    category: "Oils",
    description: "Cold-pressed from fresh whole coconuts."
  },
  {
    id: "3",
    name: "Virgin Coconut Oil - White Kernel",
    price: 19.99,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313478/6_cntvdy.png",
    category: "Oils",
    description: "Premium white kernel pure coconut oil."
  },
  {
    id: "4",
    name: "Coconut Smiles Coconut Chips",
    price: 8.99,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316776/coconut_yh6dfc.png",
    category: "Snacks",
    description: "Crunchy, natural coconut snacks."
  },
  {
    id: "5",
    name: "Butterfly Pea Tea (Niloe)",
    price: 15.00,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316114/Blue_Tea_per9qf.png",
    category: "Teas",
    description: "Made with premium Sri Lankan butterfly pea flowers (Clitoria ternatea) and dried lime, this naturally vibrant herbal tea is rich in antioxidants and offers a refreshing citrus flavor. It supports overall wellness, promotes relaxation, and creates a stunning color-changing infusion when brewed with citrus."
  },
  {
    id: "6",
    name: "Hibiscus Tea (Selinda)",
    price: 14.50,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316118/Red_Tea2_zeihlj.png",
    category: "Teas",
    description: "Crafted from carefully selected Sri Lankan dehydrated hibiscus flower (Hibiscus rosa-sinensis) petals and dried lime, our Hibiscus Tea Blend delivers a naturally vibrant, tangy, and refreshing infusion. Rich in antioxidants and vitamin C, it helps support immunity, promotes healthy digestion, and contributes to overall wellness. Enjoy it hot or iced for a deliciously refreshing experience."
  },
  {
    id: "7",
    name: "Lavanya Herbal Hair Oil",
    price: 22.00,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316123/Lavanya_vnof6p.png",
    category: "Wellness",
    description: "Traditional Ayurvedic hair nourishment."
  },
  {
    id: "8",
    name: "Rannie Carrot Body Oil",
    price: 26.00,
    image: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316124/carrot_ian2pj.png",
    category: "Wellness",
    description: "Vitamin-rich body oil for glowing skin."
  }
];